export function mapPresence(presence) {
  if (presence === 'org.matrix.msc3026.busy') return 'unavailable'
  return presence
}
